window.addEventListener('load', () => {

    let adjustmentHeight = 0
    let headerHeight = 0
    let isPC = false

    const init = () => {
        judgeDevice()
        updateAdjustmentHeight()
        updateHeaderHeight()
    }

    // PCかSPかを判定
    const judgeDevice = () => {
        if (window.innerWidth >= 989) {
            isPC = true
        } else {
            isPC = false
        }
    }
    
    /**
     * Flow画面の場合のみスクロール位置補正値を設定
     */
    const updateAdjustmentHeight = () => {
        if (window.location.pathname.includes('flow')) {
            adjustmentHeight = isPC ? 90 : 50
        } else {
            adjustmentHeight = 0
        }
    }

    const getElementHeight = selector => document.querySelector(selector)?.offsetHeight || 0
    /**
     * ヘッダーの高さを計算
     */
    const updateHeaderHeight = () => {
        const isDesktop = window.innerWidth >= 989

        headerHeight = isDesktop
            ? getElementHeight('.header-pc') + getElementHeight('.menu-list')
            : getElementHeight('.header-sp');
        headerHeight += getElementHeight('.preview-header');
    }
   
    /**
     * スクロール位置を計算して移動
     */
    const scrollToElement = (target, extraOffset = 0) => {
        const isNotFixedHeader = !!document.querySelector('.header-pc.-not-fixed')

        const offsetTop = isNotFixedHeader
            ? target.offsetTop + headerHeight + extraOffset
            : target.offsetTop - headerHeight + extraOffset
        window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    }

    /**
     * ハッシュ付きURLでロードされた場合のスクロール
     */
    const handleInitialHashScroll = () => {
        const hash = decodeURIComponent(window.location.hash)
        if (!hash) return
        
        const target = document.querySelector(hash)
        if (target) {
            // VOICEセクションの場合は特別処理
            if(target.getAttribute('id').match(/^voice\d+$/)){
                if(isPC){
                    adjustmentHeight = -80
                }else{
                    adjustmentHeight = -53
                }
                // VOICEセクションの少し上まで遷移
                window.scrollTo(0, target.offsetTop * 0.7)
            }else{
                window.scrollTo(0, 0)
            }
            
            setTimeout(() => {
                scrollToElement(target, adjustmentHeight)
            }, 10)
        }
    }

    /**
     * ページ内リンククリックイベント設定
     */
    const setupAnchorLinks = () => {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', e => {
                e.preventDefault()
                const id = anchor.getAttribute('href').slice(1)
                const target = document.getElementById(id)
                if (target) scrollToElement(target, adjustmentHeight)
            })
        })
    }

    // 初期処理
    init()
    window.addEventListener('resize', () => {
        init()
    })

    setTimeout(handleInitialHashScroll, 50)
    setupAnchorLinks()
})
